import axios from './axios';
import prepareDetails from '../helpers/prepareDetails';

class Kiosk {

    Positions = async (operatorId, companyId, subCompanyId, siteId, online, offlineSiteOpen, offlineSiteClosed, pending, authReq) => {
        const response = await axios.get(`Kiosk/Positions2/${operatorId},${companyId},${subCompanyId},${siteId},${online},${offlineSiteOpen},${offlineSiteClosed},${pending},${authReq}`);
        return response.data;
    }

    Transactions = async (installationId, startDate, endDate, showEvents, details, pageNumber) => {

        const payload = {
            installationId,
            startDate: startDate.toISOString(true),
            endDate: endDate.toISOString(true),
            showEvents,
            pageNumber,
            details: prepareDetails(details)
        }

        const transactions = await axios.put(`Kiosk/byInst/filter/`, payload);
        const summary = await axios.put(`Kiosk/byInst/summary/`, payload);

        return { transactions: transactions.data, summary: summary.data }
    }

    Detail = async (installationId, detailId) => {
        const response = await axios.get(`Kiosk/Detail/${installationId},${detailId}`);
        return response.data;        
    }

    Floats = async (installationId) => {
        const response = await axios.get(`Kiosk/Floats/${installationId}`);
        return response.data;
    }

    UpdateFloats = async (installationId, details) => {
        const response = await axios.put(`Kiosk/Floats/Update`, { installationId, details: prepareDetails(details), complete: true });
        return response.data;
    }

}

export default new Kiosk();